import React from "react"
import { Link } from "gatsby"

const ContentQuestions = ({ contentOwner, id }) => {

    const storeTitle = (e) => {
        localStorage.setItem('prevpage_title', window.document.title.replace(' | WFAA Advancement Hub', ''))
    }
    
    return (contentOwner?.contentOwner?.contentTeam?.whatWeDoPage?.link)
        ? <div><Link to={`${contentOwner.contentOwner.contentTeam.whatWeDoPage.link}?prev_page=${id}#contact`} className="contentquestions" onClick={storeTitle}>Questions</Link> about this content?</div>
        : null

}
export default ContentQuestions